/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import RazorPay from './RazorPay';
import PayPal from './PayPal';
import { showToast } from '../showTost';
import { useTranslation } from 'react-i18next';
import Stripe from './Stripe';
import Paystack from './Paystack';
import Flutterwave from './Flutterwave';
import SenangPay from './SenangPay';
import Midtrans from './Midtrans';
import PayFast from './PayFast';
import Loading from '../component/Loading';
import secureLocalStorage from "react-secure-storage";
export const ImgLoad = ({ url, style }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    return (
        <img
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${style} ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

const Payment = ({ Amount, Data, INDEX, photos, did }) => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setPaymentStatus, apiloading } = useContext(MyContext);
    const [paymentList, setPaymentList] = useState([]);
    const [selectPaymentId, setSelectPaymentId] = useState();
    const [isShow, setIsShow] = useState(false);
    const [attribute, setAttribute] = useState("");

    useEffect(() => {
        axios.get(`${ApiBaseUrl}/customer/payment_list`)
            .then((res) => {
                // console.log("payment_list", res);
                setPaymentList(res.data.payment_list);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const SelectPayment = (item) => {
        setSelectPaymentId(item.id);
        setAttribute(item.attribute);
    };

    const HandleContinue = () => {

        if (!selectPaymentId) {
            showToast({ title: t("Select Payment Method"), id: "error" });
            return;
        }

        sessionStorage.setItem("Paymentid", selectPaymentId);

        if (selectPaymentId === 1) {
            setIsShow(true);
            return;
        }

        if (selectPaymentId === 16) {
            setPaymentStatus("PaymentDone");
            return;
        }

        if (Data) {

            const PaymentData = {
                ...Data,
                status: "1",
                payment_id: selectPaymentId
            };

            sessionStorage.setItem("PaymentData", JSON.stringify(PaymentData));

            const Userid = secureLocalStorage.getItem("Userid");

            if (photos && did) {

                const formData = new FormData();
                formData.append("uid", Userid);
                formData.append("doctor_id", did);

                photos.forEach((photo) => {
                    formData.append("image", photo);
                });

                axios.post(`${ApiBaseUrl}/customer/add_patient_prescription`, formData)
                    .then((res) => {
                        // console.log("add_patient_prescription", res);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
            setIsShow(true);
        }
    };

    return (
        <div>
            <div className="h-[400px] scroll-container">
                {paymentList.length >= 1
                    ? paymentList.map((item, index) => {
                        if (item.id !== INDEX) {
                            return <div onClick={() => SelectPayment(item)} key={index} className={`payment-box border-[1px] ${selectPaymentId === item.id ? "border-[#4038FF]" : "border-[#8080803b]"}`}>
                                <div className="flex items-center gap-[10px]">
                                    <ImgLoad url={ImgBaseUrl + item.image} style="w-[60px] border-[1px] border-gray-300 rounded-[10px]" />
                                    <div className="">
                                        <h1 className='font-[500] text-[18px]'>{item.name}</h1>
                                        <p className='font-[500] leading-[18px] text-gray-800'>{item.sub_title}</p>
                                    </div>
                                </div>
                                <div className="w-[30px] check-box">
                                    <input id="radio1" className="peer hidden" type="radio" name="group1" />
                                    <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectPaymentId === item.id ? "box-activeborder" : "box-border"}`}>
                                        <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectPaymentId === item.id && "box-activebg"}`}></span>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                    : <Loading CustomeStyle="h-[100%] flex items-center justify-center" />}
            </div>

            <button onClick={HandleContinue} className='payment-btn mt-[5px]'>
                {apiloading
                    ? <div className="loader mx-auto"></div>
                    : <span>{t("Continue")}</span>}
            </button>

            {(selectPaymentId === 1 && isShow) && <RazorPay Amount={Amount} Attribute={attribute} />}
            {(selectPaymentId === 2 && isShow) && <PayPal Amount={Amount} />}
            {(selectPaymentId === 3 && isShow) && <Stripe Amount={Amount} />}
            {(selectPaymentId === 4 && isShow) && <Paystack Amount={Amount} />}
            {(selectPaymentId === 5 && isShow) && <Flutterwave Amount={Amount} />}
            {(selectPaymentId === 7 && isShow) && <SenangPay Amount={Amount} />}
            {(selectPaymentId === 9 && isShow) && <PayFast Amount={Amount} />}
            {(selectPaymentId === 10 && isShow) && <Midtrans Amount={Amount} />}

        </div>

    )
}

export default Payment
/* jshint ignore:end */